import classnames from 'classnames'
import React, { MouseEventHandler, ReactNode } from 'react'

interface IButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  isCancel?: boolean
  isType2?: boolean
  isType3?: boolean
  isOk?: boolean
  isConfirm?: boolean
  children?: ReactNode
  is1Color?: boolean
  isDisabled?: boolean
}

export const Button = (props: IButtonProps) => {
  const {
    isCancel = false,
    isOk = false,
    isConfirm = false,
    isType2 = false,
    isType3 = false,
    is1Color = false,
    isDisabled = false,
  } = props
  const buttonClassName = classnames({
    ly__btn: !isCancel,
    'ly__btn-cls': isCancel,
    'ly__btn--type2': isType2,
    'ly__btn--type3': isType3,
    OKColor: isOk,
    ConfirmColor: isConfirm,
    Button1color: is1Color,
  })

  return (
    <button type="button" className={buttonClassName} onClick={props.onClick} disabled={isDisabled}>
      {props.children || <span className="blind">layer close</span>}
    </button>
  )
}
